import { useEffect } from 'react';

function useClickOutside(
  ref: React.RefObject<HTMLDivElement>,
  setState: React.Dispatch<React.SetStateAction<boolean>>,
  state: boolean,
  blockedSelectors: string[] = [],
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      const isBlocked = blockedSelectors.some((selector) =>
        target.closest(selector),
      );

      if (isBlocked) return;

      if (ref.current && !ref.current.contains(target)) {
        setState(false);
      }
    };

    if (state) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref, setState, state, blockedSelectors]);
}

export default useClickOutside;
